import React from "react";
import medalGold from "../../image/medelGold.png";
import medalSilver from "../../image/medalSilver.png";
import { useNavigate } from "react-router-dom";

const StudentCard = () => {
  const state = true;
  const navigation = useNavigate();
  return (
    <div className="bg-white h-full rounded-md shadow-md  text-[#5e5873] ">
      <div className="   ">
        <div className="relative">
          <div>
            <img
              className="h-[150px] absolute right-0 sm:right-10"
              alt="Student"
              src={state ? medalGold : medalSilver}
            ></img>
          </div>
        </div>
        <div className="p-4  flex flex-col justify-between  h-full  ">
          <div className="flex">
            <div className=" ">
              <h1 className=" text-[#5e5873] font-medium text-sm">
                Congratulations! <span>Md Yasin</span>
              </h1>
              <p className=" text-xs mt-1">
                You have won {state ? "gold" : "Silver"} medal
              </p>
            </div>
          </div>
          <div className="">
            <p className=" text-xl text-[#7367F0] mb-2 font-semibold mt-10 ">
              CGPA 4
            </p>
            <div
              onClick={() => navigation("/subjects")}
              className=" cursor-pointer w-max text-white bg-[#7367F0]  font-semibold rounded-md text-xs px-5 py-2.5 mr-2 mb-2  "
            >
              View Results
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentCard;
